<template>
  <div class="settings">
    <div class="md-title">Settings</div>
    <UserDropdown />
  </div>
</template>
<script>
// @ is an alias to /src
import UserDropdown from '@/components/UserDropdown.vue'

export default {
  name: 'Settings',
  components: {
    UserDropdown
  }
}
</script>